export { default } from './content';
